import { render, staticRenderFns } from "./provincialZszy.vue?vue&type=template&id=96364bc4&"
import script from "./provincialZszy.vue?vue&type=script&lang=js&"
export * from "./provincialZszy.vue?vue&type=script&lang=js&"
import style0 from "./provincialZszy.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports